import React from "react";
import Grid from "@material-ui/core/Grid";
import DynamicForm from "Component/DynamicForm";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import Button from "@material-ui/core/Button";
import { instance } from "Actions/AxiosInstance";
import { withSnackbar } from "notistack";
import { ErrorMessages } from "Constants";
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setPreview as setPreviewAction } from "Actions/commonAction";

const styles = () => ({
  drawerPaper: {
    width: "30%",
  },
  table: {
    width: "100%",
  },
  TableCell: {
    padding: "14px 16px 14px 16px",
    borderBottom: "none",
  },
  TableRow: {
    borderRadius: 4,
  },
});

const frequencylist = [
  {
    displayname: "Q1",
    displayvalue: 1,
  },
  {
    displayname: "Q2",
    displayvalue: 2,
  },
  {
    displayname: "Q3",
    displayvalue: 3,
  },
  {
    displayname: "Q4",
    displayvalue: 4,
  },
];
class Postpone extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      frequencytypeid: this.props.frequencytypeid,
      objectiveid: this.props.objectiveid,
      periodtypeid: this.props.periodtypeid,
      performcycledurationid: this.props.performcycledurationid,
      resultobjective: this.props.resultobjective,
      tempperformcycledurationid: this.props.tempperformcycledurationid,
      performcycle: this.props.performcycle,
      // right: this.props.right,
    };
    this.handleChange1 = this.handleChange1.bind(this);
    this.postPone = this.postPone.bind(this);
    this.calculateProgress = this.calculateProgress.bind(this);
    this.getOkrData = this.getOkrData.bind(this);
  }

  componentDidMount() { }

  handleChange1(key, value) {
    if (key == "frequencytypeid") {
      this.setState({
        periodtypeid: 2,
        frequencytypeid: value,
      });
    }
    this.setState({
      [key]: value,
    });
  }

  calculateProgress(arrData) {
    const { resultobjective } = this.state;
    arrData.map((x) => {
      if (x.progress && x.progress[0]) {
        x.progressdetail =
          (x.progress[0].achievetargetvalue / x.progress[0].targetvalue) * 100;
        x.progressdetail = x.progressdetail.toFixed(2);
      } else {
        x.progressdetail = 0;
      }
      x.keyresult.map((k) => {
        if (k.progress && k.progress[0]) {
          k.progressdetail =
            (k.progress[0].achievetargetvalue / k.progress[0].targetvalue) *
            100;
          k.progressdetail = k.progressdetail.toFixed(2);
        } else {
          k.progressdetail = 0;
        }
      });
    });
    this.setState({
      resultobjective,
    });
  }

  getOkrData(
    objectiveid = null,
    isfirst = true,
    objectivetypeid = null,
    objectivestatusid = null,
  ) {
    const data = {
      employeeid: isfirst
        ? this.props.login.employeeid
          ? this.props.login.employeeid
          : null
        : null,
      objectiveid: objectiveid || null,
      objectivetypeid: objectivetypeid ? objectivetypeid : null,
      objectivestatusid: objectivestatusid ? objectivestatusid : null,
      periodtypeid: isfirst ? this.state.periodtypeid : null,
      frequencytypeid: isfirst
        ? this.state.frequencytypeid || this.state.tempfrequencytypeid
        : null,
      performcycledurationid: isfirst
        ? this.state.performcycledurationid ||
        this.state.tempperformcycledurationid
        : null,
    };
    instance
      .post("perform/getobjective", data)
      .then((result) => {
        this.setState(
          {
            resultobjective: result.data.result,
            backUpresult: result.data.result,
            open: false,
            searchValue3: null,
          },
          () => this.calculateProgress(this.state.resultobjective),
        );
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  postPone() {
    const data = {
      objectivestatusid: 6,
      objectiveid: this.state.objectiveid,
      frequencytypeid: this.state.frequencytypeid,
      periodtypeid: this.state.periodtypeid,
      performcycledurationid: this.state.performcycledurationid,
    };
    instance
      .post("perform/updateobjectivestatus", data)
      .then(() => {
        this.props.enqueueSnackbar(ErrorMessages.E0000, {
          variant: "success",
        });
        this.setState(
          {
            postPone: false,
           
            right: false,
            achievetargetvalue: null,
            tempobjectivestatusid: null,
          },

          () => {
            this.props.toggleDrawer("right", false);
            this.props.getOkrData();
          },

        );
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  render() {
    return (
      <div
        className="thin-scroll"
        style={{ height: "96vh", overflowY: "auto", paddingRight: 15 }}
      >
        <div className="margin-bottom-16">
          <Grid container className="margin-top-8">
            <Grid item xs={12} md={12} sm={12}>
              <p className="small-dark-secondary margin-bottom-16">
                <strong>Objective &nbsp;:&nbsp;</strong>
                {this.props.objectivetitle}
              </p>

              <div className="margin-right-16">
                <p className="normal-dark-secondary margin-bottom-4">
                  Select when to postpone Data
                </p>
                <DynamicForm
                  fields={selectinputconverter({
                    value: this.state.performcycledurationid,
                    placeholder: "",
                    label: "Select period type",
                    options: this.state.performcycle,
                    // disabled: (isformalwaysopen == true) ? true : participant[0].isSelected == false ? true : false,
                  })}
                  onChange={(value) =>
                    this.handleChange1("performcycledurationid", value)
                  }
                />
                <DynamicForm
                  fields={selectinputconverter({
                    value: this.state.frequencytypeid,
                    placeholder: "",
                    label: "Select Quarterly",
                    options: frequencylist,
                    disabled:
                      this.state.performcycledurationid == null ? true : false,
                  })}
                  onChange={(value) =>
                    this.handleChange1("frequencytypeid", value)
                  }
                />
                <div className="margin-bottom-24">
                  <Button
                    variant="contained"
                    className="btn btn-secondary-md-blue margin-right-16"
                    color="primary"
                    onClick={this.props.toggleDrawer("right", false)}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    className="btn btn-primary-md-blue"
                    color="primary"
                    onClick={() => {
                      this.postPone();
                    }}
                  >
                    Postpone
                  </Button>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  SubscriptionData: state.SubscriptionInfo.SubscriptionData,
  login: state.AuthenticationAction.login,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setPreview: setPreviewAction,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(Postpone)));
